import './functions/slider';
import './functions/utm-storage';
import './functions/utm-link';
import './functions/data-layer';

// Gutenberg Blocks
import '../../blocks/header/header';
import '../../blocks/contacts/contacts';
import '../../blocks/contacts/custom_select';
import '../../blocks/calculator/calculator';
import '../../blocks/calculator/calculator-default';
import '../../blocks/faq/accordion';
import '../../blocks/modals/modals';
